import React, { useEffect } from 'react';
import usePecoQualtrics from './usePecoQualtrics';

declare global {
    interface Window {
        QSI?: {
            API?: {
                load?: () => Promise<void>;
                unload?: () => Promise<void>;
                run?: () => void;
            };
        };
    }
}

function PecoQualtricsLoader(): React.ReactElement {
    const enablePecoQualtrics = usePecoQualtrics();

    useEffect(() => {
        if (enablePecoQualtrics) {
            window.QSI?.API?.load?.().then(window.QSI?.API?.run);
        } else {
            window.QSI?.API?.unload?.();
        }

        return () => {
            window.QSI?.API?.unload?.();
        };
    }, [enablePecoQualtrics]);

    return <></>;
}

export default PecoQualtricsLoader;
